import React from "react";
import "./NamiZen.css";

// TODO: Replace with real URLs before publishing
const APP_STORE_URL = "https://apps.apple.com/app/namizen";
const PRIVACY_POLICY_URL = "/namizen/privacy";

const NamiZen = () => (
  <div className="namizen">

    {/* ── Hero ── */}
    <section className="namizen__hero">
      <div className="namizen__container">
        <img className="namizen__logo" src="/namizen.png" alt="NamiZen" />
        <h1 className="namizen__title">NamiZen</h1>
        <p className="namizen__tagline">With you, every breath.</p>
        <p className="namizen__description">
          A beautifully calm contraction timer for labour. Track contractions, breathe through each one, and know when it's time to call your midwife.
        </p>
        <a
          className="namizen__store-badge"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download NamiZen on the App Store"
        >
          <img src="/appstore.svg" alt="Download on the App Store" className="namizen__store-badge-img" />
        </a>
      </div>
    </section>

    {/* ── Screenshots ── */}
    <section className="namizen__screenshots">
      <div className="namizen__container">
        <div className="namizen__screenshot-grid">
          <div className="namizen__screenshot"><img src="/RestingScreenshot.png" alt="Resting view" width="390" height="844" loading="lazy" /></div>
          <div className="namizen__screenshot"><img src="/ActiveScreenshot.png" alt="Active view" width="390" height="844" loading="lazy" /></div>
          <div className="namizen__screenshot"><img src="/511met.png" alt="5-1-1 met" width="390" height="844" loading="lazy" /></div>
        </div>
      </div>
    </section>

    {/* ── Features ── */}
    <section className="namizen__features">
      <div className="namizen__container">
        <h2 className="namizen__features-heading">What NamiZen does</h2>
        <ul className="namizen__feature-list">
          <li className="namizen__feature">
            <p className="namizen__feature-title">Breathing guidance</p>
            <p className="namizen__feature-desc">
              Gentle breathing prompts during each contraction help you stay
              grounded and calm when it matters most.
            </p>
          </li>
          <li className="namizen__feature">
            <p className="namizen__feature-title">5-1-1 rule indicator</p>
            <p className="namizen__feature-desc">
              Know at a glance when contractions are 5 minutes apart, 1 minute
              long, for at least 1 hour — the signal it's time to head in.
            </p>
          </li>
          <li className="namizen__feature">
            <p className="namizen__feature-title">Session history</p>
            <p className="namizen__feature-desc">
              Review your full contraction timeline so you and your birth partner
              always have the complete picture.
            </p>
          </li>
          <li className="namizen__feature">
            <p className="namizen__feature-title">PDF export</p>
            <p className="namizen__feature-desc">
              Share a clean summary of your labour progress directly with your
              midwife or care team.
            </p>
          </li>
        </ul>
      </div>
    </section>

    {/* ── Footer ── */}
    <footer className="namizen__footer">
      <a href={PRIVACY_POLICY_URL}>Privacy Policy</a>
    </footer>

  </div>
);

export default NamiZen;
